import PosthogService from '~/services/posthog/PosthogService';

export interface IBulkConfirmNoThanksClickedPayload {
  candidateId?: string;
}

/**
 * Fires when the user clicks "No Thanks" on the "review additional applications" popup.
 * Event: dental_portal:bulk_confirm:no_thanks_clicked
 */
export function fireBulkConfirmNoThanksClicked(
  payload: IBulkConfirmNoThanksClickedPayload = {},
): void {
  PosthogService.getInstance().track('dental_portal:bulk_confirm:no_thanks_clicked', {
    candidate_id: payload.candidateId,
  });
}
